import { linkStyles } from "@/components/ui/link";
import { Note } from "@/components/ui/note";
import { Separator } from "@/components/ui/separator";
import { Text } from "@/components/ui/text";
import { useAuthResend } from "../hooks/useAuthResend";
import { AuthLayout } from "./AuthLayout";

export function EmailAuthLayout({
  children,
  email,
  type,
  error: additionalError,
}: {
  children: React.ReactNode;
  email?: string;
  type: "magic-link" | "otp";
  error?: string;
}) {
  const {
    resendLoading,
    resendCooldown,
    message,
    error: resendError,
    handleResend,
  } = useAuthResend({ email, type });

  const error = additionalError || resendError;

  return (
    <AuthLayout title="Check your email" hideTestBadge>
      <div className="w-full space-y-6 mt-6 text-center">
        {children}

        {error && (
          <Note
            intent="danger"
            hideIndicator
            className="[&>div]:justify-center"
          >
            {error}
          </Note>
        )}

        {message && (
          <Note intent="info" hideIndicator className="[&>div]:justify-center">
            {message}
          </Note>
        )}

        <div>
          <Text className="text-sm text-muted-foreground mb-2 mr-2">
            Didn't receive the email?
          </Text>
          <button
            type="button"
            onClick={handleResend}
            disabled={!email || resendCooldown > 0 || resendLoading}
            className="text-sm text-blue-600 hover:text-blue-500 disabled:text-gray-400 disabled:cursor-not-allowed underline"
          >
            {resendLoading
              ? "Sending..."
              : resendCooldown > 0
                ? `Resend in ${resendCooldown}s`
                : "Resend email"}
          </button>
        </div>

        <Separator />
      </div>

      <div className="mt-4 -mb-2">
        <Text elementType="p" size="xs" className="text-foreground/60">
          Having trouble? Check your spam folder or{" "}
          <a
            href="mailto:support@blis.app"
            className={linkStyles({ intent: "primary" })}
          >
            contact support
          </a>
        </Text>
      </div>
    </AuthLayout>
  );
}
